import React, { useState } from "react";
import IconAction from "../../icons/action";
import { Dropdown, Space } from "antd";
import { DeleteOutlined, FormOutlined } from "@ant-design/icons";
import UpdateUser from "./UpdateUser";
import DeleteUser from "./DeleteUser";
import { useTranslation } from "react-i18next";

const UserTable = ({ data, getData, isSupervisor }) => {
    const { t } = useTranslation();
    const [isShowUpdate, setIsShowUpdate] = useState(false);
    const [isShowDelete, setIsShowDelete] = useState(false);
    const [edit, setEdit] = useState(null);
    const myUsername = sessionStorage.getItem("username");

    const itemsGetter = (user) => {
        const disabled = user.username === myUsername;
        return [
            { label: <span onClick={() => onUpdate(user)}>{t("Update")}</span>, key: "update", icon: <FormOutlined /> },
            { label: <span onClick={() => onDelete(user)}>{t("Delete")}</span>, key: "delete", icon: <DeleteOutlined />, disabled },
        ];
    };

    const onUpdate = (user) => {
        setEdit(user);
        setIsShowUpdate(true);
    };

    const onDelete = (user) => {
        setEdit(user);
        setIsShowDelete(true);
    };

    return (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="px-6 py-3">
                            {t("first name")}
                        </th>
                        <th scope="col" className="px-6 py-3">
                            {t("last name")}
                        </th>
                        <th scope="col" className="px-6 py-3">
                            {t("email")}
                        </th>
                        <th scope="col" className="px-6 py-3">
                            {t("username")}
                        </th>
                        {isSupervisor === "true" && <th scope="col" className="px-6 py-3"></th>}
                    </tr>
                </thead>
                <tbody>
                    {data.map((user) => (
                        <tr key={user.id} className="border-b dark:bg-gray-800 dark:border-gray-700">
                            <td className="px-6 py-4">{user.first_name}</td>
                            <td className="px-6 py-4">{user.last_name}</td>
                            <td className="px-6 py-4">{user.email}</td>
                            <td className="px-6 py-4">{user.username}</td>
                            {isSupervisor === "true" && (
                                <td className="px-6 py-4">
                                    <Dropdown menu={{ items: itemsGetter(user) }} trigger={["click"]}>
                                        <a onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                <IconAction />
                                            </Space>
                                        </a>
                                    </Dropdown>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            <UpdateUser user={edit} isModalOpen={isShowUpdate} setIsModalOpen={setIsShowUpdate} getData={getData} />
            <DeleteUser user={edit} isModalOpen={isShowDelete} setIsModalOpen={setIsShowDelete} getData={getData} />
        </div>
    );
};

export default UserTable;
